import { render } from "./area-echarts.vue?vue&type=template&id=1c617d60&scoped=true"
import script from "./area-echarts.vue?vue&type=script&lang=js"
export * from "./area-echarts.vue?vue&type=script&lang=js"

import "./area-echarts.vue?vue&type=style&index=0&id=1c617d60&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c617d60"]])

export default __exports__